import React from "react";

export default function WarningCloverfield({
  width = 82,
  height = 82,
  ...rest
}: {
  width?: number;
  height?: number;
  [x: string]: any;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 82 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.30363 35.4385L35.4386 3.30361C38.5101 0.232131 43.4899 0.232131 46.5614 3.30361L78.6964 35.4386C81.7679 38.5101 81.7679 43.49 78.6964 46.5614L46.5614 78.6964C43.4899 81.7679 38.5101 81.7679 35.4386 78.6964L3.30363 46.5614C0.232124 43.4899 0.232124 38.5101 3.30363 35.4385Z"
        fill="#473F2A"
        stroke="#DCAB2E"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M37.0765 18.0712C37.0352 17.4924 37.4936 17 38.074 17H43.926C44.5064 17 44.9648 17.4924 44.9235 18.0712L43.0663 44.0712C43.029 44.5946 42.5935 45 42.0689 45H39.9311C39.4065 45 38.971 44.5946 38.9337 44.0712L37.0765 18.0712Z"
        fill="#DCAB2E"
      />
      <path
        d="M36.288 57.3048L40.3048 53.288C40.6888 52.904 41.3112 52.904 41.6952 53.288L45.712 57.3048C46.096 57.6888 46.096 58.3112 45.712 58.6952L41.6952 62.712C41.3112 63.096 40.6888 63.096 40.3048 62.712L36.288 58.6952C35.904 58.3112 35.904 57.6888 36.288 57.3048Z"
        fill="#DCAB2E"
      />
    </svg>
  );
}
